import { useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants'
import {
    IArchivesAssetsDetail,
    IAssetsListDetail,
    IAssetsListSearchFields,
    IAssetsDetail,
    assetsListService,
} from './assetsListService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { IPgProps, ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { convertRes2Blob } from '@/utils/exportFile'


export const assetsListModel = createModel(function () {
    const { setLoadingInfo } = useGlobalModel()
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IAssetsListDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IAssetsListSearchFields>({ status: ['assets-status.isUse', 'assets-status.leaveUnused'] })
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IAssetsListDetail[]>([])
    //表格多选id值
    const [selectedIdKeys, setSelectedIdKeys] = useState<any>([])
    const [goodsList, setGoodsList] = useState<any>([])
    //物资编码点击详情
    const [materialCodeRow, setMaterialCodeRow] = useState<IAssetsListDetail>()
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAssetsListSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            status: searchValue?.status ? searchValue?.status.join(',') : '',
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            type: "assets.storage",
        }
        let { retData } = await assetsListService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        let newlist = records.map((item: any) => {
            return {
                ...item,
                departmentStatus: item.departmentStatus == 'assets-status.isUse' ? 1 : item.departmentStatus == 'assets-status.leaveUnused' ? 0 : null
            }
        })
        setDataSource(newlist)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IAssetsListSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({ status: ['assets-status.isUse', 'assets-status.leaveUnused'] })
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    const [materialCodeVisible, setMaterialCodeVisible] = useState<boolean>(false)
    const [uesrVisible, setUesrVisible] = useState<boolean>(false)
    const [transferLogVisible, setTransferLogVisible] = useState<boolean>(false)
    const [goodsTransferVisible, setGoodsTransferVisible] = useState<boolean>(false)



    //导出
    const exportData = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '快速导出中' })
        try {
            const searchParams = {
                ...searchParam,
                status: searchParam?.status ? searchParam?.status.join(', ') : '',
                ...{ ids: selectedIdKeys.length > 0 ? selectedIdKeys.toString() : null },
                pageSize: -1,
                pageNum: 1,
                type: "assets.storage"
            }
            let result = await assetsListService.export(searchParams)
            result && setLoadingInfo({ loadingVisible: false, txt: '' })
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }
    //使用人导出
    const exportUser = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '快速导出中' })
        try {
            const searchParams = {
                userCode: materialCodeRow?.userCode,
                pageSize: -1,
                pageNum: 1,
                typeList: ['assets.receive', 'assets.transfer']
            }
            let result = await assetsListService.exportUser(searchParams)
            result && setLoadingInfo({ loadingVisible: false, txt: '' })
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }
    //下载模板
    const downloadTpl = async () => {
        let result = await assetsListService.downloadTpl();
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        materialCodeRow,
        materialCodeVisible,
        uesrVisible,
        selectedIdKeys,
        transferLogVisible,
        goodsTransferVisible,
        goodsList,
        /***method***/
        setGoodsList,
        setGoodsTransferVisible,
        setTransferLogVisible,
        setSelectedIdKeys,
        setUesrVisible,
        setMaterialCodeVisible,
        setMaterialCodeRow,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportData,
        exportUser,
        downloadTpl
    }
})
